export const css = {
	root: '_1mCJBIMB',
	continue: '_1DtxTjEo',
	inus: 'gR2cCLX8',
	misc: '_3iNk7Edz',
	title: '_2WE2dwkB',
	' _key': 'landing-page/info-gathering-view'
};

export default css;
